export default {
    data() {
        return {
            fromDate: null,
            toDate: null,
            month:null,
            lang: {
                formatLocale: {
                    firstDayOfWeek: 1,
                },
                monthBeforeYear: false,
            },
            selectedStore:null,
            showSettlementDropdown:true,
            selectedSettlement: null,
            typeList: [
                {
                    value: 'settlement',
                    label: 'Settlement'
                },
                {
                    value: 'vat',
                    label: 'VAT'
                },
                {
                    value: 'extraMilesSplitReport',
                    label: 'ExtraMiles Split Report'
                },
                {
                    value: 'euronetDccReport',
                    label: 'Euronet DCC Report'
                },
                {
                    value: 'storeSettlementReport',
                    label: 'Settlement For Store'
                },
            ],
            type: 'settlement',
            requestParams: {type:'aggregate',settlementStatus : 'completed'},
            storeRequestParams: {},
        }
    },
    methods: {
        customSettlementNameForMultiselect (item) {
            return `${item.uuid}/${item.user_account.user.email}`
        },
    },
    watch: {
        type(val) {
            this.month = null
            this.selectedSettlement = null
            this.selectedStore = null
            this.fromDate = null
            this.toDate = null
            this.showSettlementDropdown = false
            if(val == 'settlement'){
                this.showSettlementDropdown = true
            }
        }
    },
}